export default "__VITE_ASSET__9ed468f7__"